import axios, { AxiosError } from 'axios';

import { Config } from '@/config';

export interface LoginResult {
  token: string;
}

// `accessReference` is the customer's request a superadmin gives to enter a
// customer community (COCO-3425); the API refuses the entry without one. It goes
// in a header, URI-encoded, so it stays out of the URLs the WAF logs.
export async function login(communityId: number, accessReference?: string): Promise<LoginResult> {
  const response = await axios({
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      ...(accessReference && { 'X-Access-Reference': encodeURIComponent(accessReference) }),
    },
    method: 'get',
    responseType: 'json',
    url: `${Config.accounts.url}/login?communityId=${communityId}`,
  });
  if (response.status !== 200 && response instanceof AxiosError) throw new Error(response.message);
  return response.data as LoginResult;
}

export default { login };
